import * as React from "react";
import { useState, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import Notification from "../../components/common/Notification";
import { useNavigate, Link } from 'react-router-dom';

/* TOOLBAR */

import SaveIcon from "@mui/icons-material/Save";
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton"

import PasswordTopo from "./topo";
import Usuario from "../../components/classes/Usuario";
import UsuarioDataset from "../../components/data/UsuarioDataSet";

import { useTranslation } from "react-i18next";

export const PasswordDetalhe = () => {
  const { t } = useTranslation();
  /* Hook States */

  const [usuario, setUsuario] = useState<Usuario>(JSON.parse(String(localStorage.getItem("UsuarioCache"))));

  const [open, setOpen] = React.useState(false);

  const [oldPassword, SetOldPassword] = React.useState("");
  const [newPassword, SetNewPassword] = React.useState("");
  const [otherNewPassword, SetOtherNewPassword] = React.useState("");

  const navigate = useNavigate();
  const refreshPage = () => {
    localStorage.clear();
    navigate('/');
    window.location.reload();
  }

  /* Component de Confirmação */

  const Mensagem = (titulo: string, mensagem: string, opt: Number) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons:
        opt === 1
          ? [
            { label: "Yes", onClick: () => handleAtualizaClick() },
            { label: "No", onClick: () => setOpen(false) },
          ]
          : opt === 2
            ? [
              { label: "Yes", onClick: () => handleAtualizaClick() },
              { label: "No", onClick: () => setOpen(false) },
            ]
            : opt === 3
              ? [{ label: "Ok", onClick: () => setOpen(false) }]
              : [{ label: "Ok", onClick: () => setOpen(false) }],
    });
  };

  const handleAtualizaClick = () => {
    var ds: UsuarioDataset = new UsuarioDataset();
    var dados: string[] = [];
    dados.push(base64_encode(oldPassword));
    dados.push(base64_encode(newPassword));
    dados.push(base64_encode(otherNewPassword));
    dados.push(base64_encode(usuario.email));
    ds.AtualizarSenha(dados).then((result) => {
      if (result) {
        MensagemOk(t("pages.password.text.passwordChange"), t("pages.password.text.passwordChangeSuccess"), () => refreshPage());
      }
      else {
        MensagemOk(t("common.attention"), t("pages.password.text.passwordChangeFailure"));
      }
    });
  };

  const MensagemOk = (titulo: string, mensagem: string, action: any = undefined) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [{
        label: "Ok", onClick: () => {
          setOpen(false);
          if (action) {
            action();
          }
        }
      }]
    });
  };

  const handlerOldPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    SetOldPassword(event.target.value);
  };

  const handlerNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    SetNewPassword(event.target.value);
  };

  const handlerOtherNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    SetOtherNewPassword(event.target.value);
  };

  const handleDialogSave = () => {
    let texto = " atualizar ";
    if (ValidarInputs(texto)) {
      Mensagem(
        t("pages.password.text.confirm"),
        t("pages.password.text.confirmQuestion", texto),
        1
      )
    }
  };

  const ValidarInputs = (operacao: string): boolean => {
    let Messages: string[] = [];
    if (oldPassword.length === 0)
      Messages.push(`\n\r${t("pages.password.text.oldPasswordRequired")}`);
    if (newPassword.length === 0)
      Messages.push(`\n\r${t("pages.password.text.newPasswordRequired")}`);
    if (otherNewPassword.length === 0)
      Messages.push(`\n\r${t("pages.password.text.newPasswordConfirmationRequired")}`);
    if (otherNewPassword !== newPassword)
      Messages.push(`\n\r${t("pages.password.text.passwordNoMatched")}`);
    if (oldPassword === newPassword)
      Messages.push(`\n\r${t("pages.password.text.newPasswordAndOldPasswordEqual")}`);

    let multiplos: Number = 0;
    multiplos = Messages.length;
    if (multiplos > 0) {
      let msgbuilder: string = "";
      Messages.map((Messages) => (msgbuilder += `\n\r` + Messages));
      let msg =
        t("pages.password.text.pleaseVerify") +
        (multiplos > 1
          ? t("pages.password.text.verifyItemPlural")
          : t("pages.password.text.verifyItemSingular")) +
        msgbuilder;
      Mensagem(t("pages.password.text.fillingError"), msg, 3);
    }
    return multiplos === 0;
  };

  const Bind = () => {
    const ListItem = styled("li")(({ theme }) => ({
      margin: theme.spacing(0.5),
    }));

    return (
      <div className="container">
        <React.Fragment>
          < PasswordTopo />
          <div className="containerToolbar">
            <Tooltip title={t("pages.password.text.passwordUpdate")}>
              <IconButton onClick={handleDialogSave} > <SaveIcon /></IconButton>
            </Tooltip>
          </div>
          <div className="insiderContainer">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={1}></Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  id="password"
                  name="password"
                  label={t("pages.password.text.actualPassword")}
                  type="password"
                  autoComplete="current-password"
                  fullWidth
                  variant="outlined"
                  value={oldPassword}
                  onChange={handlerOldPasswordChange}
                />
              </Grid>
              <Grid item xs={12} sm={1}></Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  id="password"
                  name="password"
                  label={t("pages.password.text.newPassword")}
                  type="password"
                  autoComplete="current-password"
                  fullWidth
                  variant="outlined"
                  value={newPassword}
                  onChange={handlerNewPasswordChange}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  id="password"
                  name="password"
                  label={t("pages.password.text.newPasswordConfirmation")}
                  type="password"
                  autoComplete="current-password"
                  fullWidth
                  variant="outlined"
                  value={otherNewPassword}
                  onChange={handlerOtherNewPasswordChange}
                />
              </Grid>
            </Grid>
          </div>
        </React.Fragment>
      </div>
    );
  };
  return Bind();
};
